import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import TenantsApi from '../generated/api/Tenants';

export default (service: Servicelayer) => ({
  ...TenantsApi(service),

  // Add custom calls here

});
